<template>
  <section>
    <PageTitle title="Baby Names" v-if="!hidePageTitle"
               v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/baby_names',title:'Baby Names'}]"
    />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox-content">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Name</label>
                  <input placeholder="Name" id="name" class="form-control" v-model="name"/>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>
                    Select Gender
                  </label>
                  <select v-model="gender"
                          class="form-control styleSelectElement">
                    <option value="" disabled
                    >
                      Select Gender
                    </option>
                    <option :value="'M'"
                    >
                      Boy
                    </option>
                    <option :value="'F'"
                    >
                      Girl
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                <label>
                  Status
                </label>
                <select v-model="status"
                        class="form-control styleSelectElement">
                  <option value="" disabled
                  >
                    Select Status
                  </option>
                  <option :value="BabyNameStatuses.APPROVED">
                    {{BabyNameStatuses.APPROVED}}
                  </option>
                  <option :value="BabyNameStatuses.PENDING">
                    {{BabyNameStatuses.PENDING}}
                  </option>
                  <option :value="BabyNameStatuses.REJECTED">
                    {{BabyNameStatuses.REJECTED}}
                  </option>
                </select>
              </div>
              </div>
              <div class="col-md-2">
                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_btn" type="button"><i class="fa fa-search"></i> Search</button>
                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_btn"><i class="fa fa-refresh" type="button"></i> Refresh</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="ibox">
                <div class="ibox-content">
                  <div class="table-responsive">
                    <table class="table table-striped table-responsive table-bordered table-hover"
                           id="babyNaming">
                      <thead>
                      <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Meaning in urdu</th>
                        <th>Gender</th>
                        <th>Meaning in english</th>
                        <th>Status</th>
                        <th>Created</th>
                        <th>Modified</th>
                      </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditBabyName ref="editBabyNames" />
  </section>
</template>

<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import Multiselect from "vue-multiselect";
import state from "@/store";
import EditBabyName from "@/components/BabyNames/EditBabyName.vue";
import {BabyNameStatuses} from "@/Utils/Constants/BabyNameStatuses";

export default {
  name: "BabyNames",
  components: {EditBabyName, Multiselect, PageTitle},
  data(){
    return {
      gender: '',
      name: '',
      dataTable:'',
      status:'',
    }
  },
  computed: {
    BabyNameStatuses() {
      return BabyNameStatuses
    },
    role() {
      return this.$store.getters.user.userRolesById[0].role;
    }
  },
  props: {
    hidePageTitle: {
      type: Boolean,
      default: false,
    }
  },
  async mounted() {
    await this.initializeDatatable();
    await this.jQueryOnSearchButton();
    await this.jQueryOnRefreshButton();
  },
  methods: {
    initializeDatatable: function(){
      let self = this;
      let processingURL = state.getters.mainAppURL + "baby_names";
      self.dataTable = $('#babyNaming').DataTable({
        "processing": true,
        "serverSide": true,
        "dom":'ltipr',
        "lengthMenu": [10, 25, 50, 100, 250],
        autoWidth: false,
        "order": [[1, "asc"]],
        'language': {
          'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
              '                <div class="sk-double-bounce1"></div>\n' +
              '                <div class="sk-double-bounce2"></div>\n' +
              '              </div>'
        },
        "ajax": {
          url: processingURL,
          type: "post",
          data: function ( d ) {
            return JSON.stringify( d );
          },
          headers: {
            "Content-type": "application/json; charset=utf-8"
          },
          beforeSend:  (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
          },
          statusCode: {
            401: () => {
              this.updateRefreshTokenInDataTable(this.dataTable);
            }
          }
        },
        "columnDefs": [
          {
            "orderable": false, "targets": [0, 2, 3, 4, 5, 6, 7]
          },
          {
            'className': "text-center", 'aTargets': [0, 1, 2, 3, 4, 5, 6, 7]
          },
          {
            "targets": [1, 2, 3, 4, 5, 6 ], "searchable": false
          },
          { "width": "30%", "targets": 4 }
        ],
        "columns": [
          {
            "data": "id",
            "name": "id",
            "render": function(data, type, row,dataIndex){
              return dataIndex.row+1
            }
          },
          {
            "data": "name",
            "name": "name",
            "render": function(data, type, row){
              if (self.role === 'ROLE_ADMIN') {
                return "<a class='editName' data-id=" + row.id + ">" + data + "</a>";
              } else {
                return "<a href='javascript:void(0)' data-id=" + row.id + ">" + data + "</a>";
              }
            }
          },
          { "data": "urduName",
            "name":"urduName"
          },
          { "data": "gender",
            "name":"gender",
            "render": function (data) {
              if(data === 'M') {
                return "<span class='m_tip label label-info'>Boy</span>";
              } else {
                return "<span class='m_tip label label-danger pink'>Girl</span>";
              }
            }
          },
          {
            "data": "meanings",
            "name": "meanings",
            "render": function (data) {
              return "<span class='' title='" + data + "'>" + (data.length > 50 ? data.slice(0, 50) + '...' : data) + "</span>";
            }
          },

          { "data": "status",
            "render": function (data) {
            let badge = ''
            if (data === BabyNameStatuses.APPROVED) {
              badge = 'badge-success'
            } else if (data === BabyNameStatuses.PENDING) {
              badge = 'badge-secondary'
            } else if (data === BabyNameStatuses.REJECTED) {
              badge = 'badge-danger'
            }
              return "<span class='m_tip badge " + badge + "'>" + data + "</span>";
            }
          },
          {
            "data": "created",
            "name":"created",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          {
            "data": "modified",
            "name":"modified",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
        ],
        "drawCallback": function( settings ) {
          $('.editName').click(function (){
            let id = $(this).attr("data-id");
            self.$refs.editBabyNames.load(id)
          });
        }
      });
      $.fn.dataTable.ext.errMode = 'none';
    },
    jQueryOnSearchButton (){
      let self= this;
      $(".search_filter_btn").click( function () {
        self.resetDatatableColumns();
        if(self.name){
          self.dataTable.column(1).search(self.name);
        }if(self.gender){
          console.log(self.gender)
          self.dataTable.column(3).search(self.gender);
        }if(self.status){
          self.dataTable.column(5).search(self.status);
        }
        self.dataTable.draw();
      });
    },
    jQueryOnRefreshButton(){
      let self= this;
      $(".refresh_filter_btn").click( function () {
        self.resetDatatableColumns();
        self.name = '';
        self.gender = '';
        self.status = '';
        self.dataTable.draw();
      });
    },
    resetDatatableColumns (){
      this.dataTable.column(1).search('');
      this.dataTable.column(3).search('');
      this.dataTable.column(5).search('');
    },
    tableDraw: function () {this.dataTable.draw()},  }
}
</script>

<style>
.pink {
  background-color: #FF92A5 !important;
}
.max-width-100 {
  max-width: 100px;
}
</style>